import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";

export function SectionCard({
  title,
  icon,
  children
}: {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <Box
      bg="white"
      border="1px solid #E2E8F0"
      borderRadius="10px"
      p="20px 24px"
    >
      <Flex align="center" gap="8px" mb="18px">
        <Box color="#4A90D9">{icon}</Box>
        <Text fontSize="14px" fontWeight="700" color="#2D3748">
          {title}
        </Text>
      </Flex>
      {children}
    </Box>
  );
}
